import React, { useEffect, useState, lazy } from 'react';
import { ChevronLeftIcon, ChevronRightIcon, EyeIcon } from 'lucide-react';
const IMAGES = [{
  src: 'https://cdn.magicpatterns.com/uploads/qsEbeT9uh2z6tLzZSsqeYT/image.png',
  alt: 'Comunidad de WhatsApp - Estudiantes de Abogacía Argentina - 583 miembros'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/22EqPhc2ZwGqp5q8ZNbR2D/Captura_de_pantalla_2026-03-06_125802.png',
  alt: 'Índice de Contenidos'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/9EVMuCBLjKmqR7FYRdM9Gc/Captura_de_pantalla_2026-03-06_125822.png',
  alt: 'Procuración Jurídica Argentina 2026'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/uX9dJrtHEGMH1RqNmhhdUq/Captura_de_pantalla_2026-03-06_125851.png',
  alt: 'Mi primera mirada al expediente'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/vHJrkVpHvUT7Y2PrwkN1wU/Captura_de_pantalla_2026-03-06_125913.png',
  alt: 'Introducción: Diccionario Jurídico'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/4yhET678BWdJKkGtxGmXF8/Captura_de_pantalla_2026-03-06_125936.png',
  alt: 'Derecho Civil y Comercial'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/tAvgAsHT9rYzKwZ96y6bei/Captura_de_pantalla_2026-03-06_125953.png',
  alt: 'Escritos Judiciales Paso a Paso'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/7yiTNDvTtZGPikNfUbVrbB/Captura_de_pantalla_2026-03-06_130004.png',
  alt: 'Conceptos Fundamentales'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/bhS7ShqaggBK9WxpKmuP3Q/Captura_de_pantalla_2026-03-06_130027.png',
  alt: 'Cómo Subir un Escrito al Portal del PJN'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/x3UsE44LKCQZ92qDwPGP6D/Captura_de_pantalla_2026-03-06_130043.png',
  alt: 'Requisitos Previos Indispensables'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/bcxacZvaKiP8f96A653U1Y/Captura_de_pantalla_2026-03-06_130106.png',
  alt: 'Fundamentos de los Honorarios Profesionales'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/94bsWidhd9GynVmRNNhy3n/Captura_de_pantalla_2026-03-06_130144.png',
  alt: 'Colegios de Abogados: Sus Aliados Profesionales'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/6takeL2fW2TpbbSEJ5Vzx9/Captura_de_pantalla_2026-03-06_130212.png',
  alt: 'Guía Práctica: Tu Primera Entrevista con Clientes'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/bCzR3ndDWmEqpPAybPSJtD/Captura_de_pantalla_2026-03-06_130220.png',
  alt: 'Módulo Introductorio: La Primera Entrevista'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/kK63Z4Qh6zB19pEpWRstnY/Captura_de_pantalla_2026-03-06_130242.png',
  alt: 'Pasos Previos al Ejercicio Profesional'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/8AVvHsfSPWKfSAzjEjmHKr/Captura_de_pantalla_2026-03-06_130253.png',
  alt: 'Gestión y Legalización del Título Universitario'
}];
export function ProductPreviewCarousel() {
  const [current, setCurrent] = useState(0);
  // Auto-advance every 4 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrent(prev => (prev + 1) % IMAGES.length);
    }, 4000);
    return () => clearInterval(interval);
  }, []);
  const goTo = (index: number) => setCurrent(index);
  const prev = () => setCurrent(c => (c - 1 + IMAGES.length) % IMAGES.length);
  const next = () => setCurrent(c => (c + 1) % IMAGES.length);
  return <section className="w-full bg-gradient-to-b from-gray-900 to-black py-14 px-4" data-id="element-504">
      <div className="max-w-4xl mx-auto" data-id="element-505">
        {/* Header */}
        <div className="text-center mb-8" data-id="element-506">
          <div className="inline-flex items-center gap-2 bg-yellow-400 text-black font-black text-sm px-4 py-2 rounded-full mb-4 uppercase" data-id="element-507">
            <EyeIcon className="h-4 w-4" data-id="element-508" />
            Mirá por dentro
          </div>
          <h2 className="text-3xl md:text-5xl font-black text-white uppercase leading-tight" data-id="element-509">
            Con todo esto y mucho más te vas a encontrar adentro
          </h2>
        </div>

        {/* Carousel */}
        <div className="relative" data-id="element-510">
          {/* Main image */}
          <div className="relative overflow-hidden rounded-xl shadow-2xl bg-black border border-gray-700 transition-all duration-500 ease-in-out" data-id="element-511">
            <div className="relative w-full" data-id="element-512">
              {IMAGES.map((img, i) => <div key={i} className={`w-full transition-opacity duration-500 ease-in-out ${i === current ? 'relative opacity-100 z-10' : 'absolute top-0 left-0 opacity-0 pointer-events-none z-0'}`} data-id="element-513">
                  <img src={img.src} alt={img.alt} className="w-full h-auto object-contain" loading={i === 0 ? 'eager' : 'lazy'} data-id="element-514" />
                </div>)}
            </div>

            {/* Arrows */}
            <button onClick={prev} className="absolute left-3 top-1/2 -translate-y-1/2 bg-black/60 hover:bg-black/80 text-white rounded-full p-2 transition-colors backdrop-blur-sm z-20" aria-label="Anterior" data-id="element-515">
              <ChevronLeftIcon className="h-6 w-6" data-id="element-516" />
            </button>
            <button onClick={next} className="absolute right-3 top-1/2 -translate-y-1/2 bg-black/60 hover:bg-black/80 text-white rounded-full p-2 transition-colors backdrop-blur-sm z-20" aria-label="Siguiente" data-id="element-517">
              <ChevronRightIcon className="h-6 w-6" data-id="element-518" />
            </button>

            {/* Counter badge */}
            <div className="absolute top-3 right-3 bg-black/70 text-white text-xs font-bold px-3 py-1 rounded-full backdrop-blur-sm z-20" data-id="element-519">
              {current + 1} / {IMAGES.length}
            </div>
          </div>

          {/* Dots */}
          <div className="flex justify-center gap-2 mt-5" data-id="element-520">
            {IMAGES.map((_, i) => <button key={i} onClick={() => goTo(i)} className={`rounded-full transition-all duration-300 ${i === current ? 'w-8 h-3 bg-yellow-400' : 'w-3 h-3 bg-gray-600 hover:bg-gray-400'}`} aria-label={`Ir a imagen ${i + 1}`} data-id="element-521" />)}
          </div>
        </div>

        {/* Caption */}
        <p className="text-center text-gray-400 text-sm mt-4" data-id="element-522">
          📖 Capturas reales del contenido de la guía
        </p>
      </div>
    </section>;
}